import { UiLoader } from '@experiences/ui-common';
import React, { useEffect } from 'react';

import { clearAuthStorage } from '../auth/utils/ClearStorage';

export default function ClearAuthStorageComponent() {
    useEffect(() => {
        clearAuthStorage();
    }, []);

    return <UiLoader type="full" />;
}
